import { ExclamationCircleIcon } from "@heroicons/react/24/solid"

import { QuickSendSelectionItem, StoreProduct } from "../types/productSelection"
import { Bee } from "./BeeKit"
import { LowInventoryNofitier } from "./ProductSelection/LowInventoryNotifier"
import { formatSupportedRegions, ON_DEMAND_SHIPPED_SEPARATELY_WARNING } from "~/src/lib/shippingRestrictions"

export type SelectionItemWarningsProps = {
  quickSendId: number
  selectionItem: QuickSendSelectionItem
}

export function SelectionItemWarnings(props: SelectionItemWarningsProps) {
  const { quickSendId, selectionItem } = props
  const storeProduct = selectionItem.selectable as StoreProduct
  // We'll add handling StoreKit here later

  const { inventoryCount, inventoryRequired, supportedRegions, onDemand } = storeProduct

  return (
    <div className="flex flex-col gap-2">
      {inventoryRequired ? (
        <LowInventoryNofitier
          lowInventoryThreshold={3}
          inventoryCount={inventoryCount}
          editSelectionUrl={`/quick_sends/${quickSendId}/selections`}
        />
      ) : null}
      {supportedRegions.length > 0 ? (
        <>
          {onDemand && (
            <Bee.Cue
              className="text-gray-500 italic"
              tipProps={{ className: "not-italic text-black" }}
              tip={ON_DEMAND_SHIPPED_SEPARATELY_WARNING}
            >
              Ships separately
            </Bee.Cue>
          )}

          <div className="flex items-center gap-1">
            <ExclamationCircleIcon className="h-4 w-4 text-yellow-500" />
            <p className="text-xs text-nowrap">Can only be shipped to {formatSupportedRegions(supportedRegions)}</p>
          </div>
        </>
      ) : null}
    </div>
  )
}
